import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { ContractsService } from '@appStore/contracts/services/contracts.service';

import * as contractsActions from '@appStore/contracts/actions/contracts.actions';
import { ContractsActionTypes } from '@appStore/contracts/actions/contracts.actions';

@Injectable()
export class ContractsEffects {
  constructor(private router: Router, private contractsService: ContractsService, private actions$: Actions) {}

  contractLoadData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ContractsActionTypes.ContractLoadData),
      map((action: contractsActions.ContractLoad) => action.payload),
      exhaustMap(meteringPointId => {
        return this.contractsService.getContractByMeteringPoint(meteringPointId).pipe(
          map(item => new contractsActions.ContractLoadSuccess(item)),
          catchError(error => of(new contractsActions.ContractLoadFail(error)))
        );
      })
    );
  });

  contracByMeteringPointAndPeriodLoadData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ContractsActionTypes.ContractForDateIntervalLoadData),
      map((action: contractsActions.ContractForDateIntervalLoad) => action.payload),
      exhaustMap(request => {
        return this.contractsService.getContractsByMeteringPointAndDateInterval(request.meteringPointId, request.from, request.to).pipe(
          map(items => new contractsActions.ContractForDateIntervalLoadSuccess(items)),
          catchError(error => of(new contractsActions.ContractForDateIntervalLoadFail(error)))
        );
      })
    );
  });

  contractsLoadData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ContractsActionTypes.ContractsLoadData),
      map((action: contractsActions.ContractsLoad) => action.payload),
      exhaustMap(contractsRequest => {
        return this.contractsService.getContractsByMeteringPointIds(contractsRequest).pipe(
          map(items => new contractsActions.ContractsLoadSuccess(items)),
          catchError(error => of(new contractsActions.ContractsLoadFail(error)))
        );
      })
    );
  });
 
  loadAgreementProductData$ = createEffect(() => {
    return   this.actions$.pipe(
      ofType(ContractsActionTypes.AgreementProductsLoadData),
      exhaustMap(action => {
        return this.contractsService.getAllAgreementProducts().pipe(
          map(items => new contractsActions.AgreementProductsLoadSuccess(items)),
          catchError(error => of(new contractsActions.AgreementProductsLoadFail(error)))
        );
      })
    );
  });

  hasContractAdditions$ = createEffect(() => {
    return   this.actions$.pipe(
      ofType(ContractsActionTypes.HasContractAdditions),
      map((action: contractsActions.HasContractAdditions) => action.payload),
      exhaustMap(request =>
        this.contractsService.getHasContractAdditions(request).pipe(
          map(validItem => new contractsActions.HasContractAdditionsSuccess(validItem)),
          catchError(error => of(new contractsActions.HasContractAdditionsSuccess(error)))
        )
      )
    );
  });

  agreementAdditionsEsignLoad$ = createEffect(() =>{
    return this.actions$.pipe(
      ofType(ContractsActionTypes.AgreementAdditionEsignLoad),
      exhaustMap(action => {
        return this.contractsService.getAgreementAdditionEsign().pipe(
          map(items => new contractsActions.AgreementAdditionsEsignLoadSuccess(items)),
          catchError(error => of(new contractsActions.AgreementAdditionsEsignLoadFail(error)))
        );
       })
    );
  });


  agreementAdditionProductExclusionsLoad$ = createEffect(() => {
    return   this.actions$.pipe(
      ofType(ContractsActionTypes.AgreementAdditionProductExclusionsLoadData),
      exhaustMap(action => {
        return this.contractsService.getAgreementAdditionProductExclusions().pipe(
          map(items => new contractsActions.AgreementAdditionProductExclusionsLoadSuccess(items)),
          catchError(error => of(new contractsActions.AgreementAdditionProductExclusionsLoadFail(error)))
        );
      })
    );
  });
}
